module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk_sekundærlogo_pos(svart).a05ab8e8.svg";